import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-overlay-feature-list",
  imports: [TranslocoDirective],
  template: `
    <ul *transloco="let t" class="ml-5 flex list-disc flex-col gap-2">
      @for (featureKey of featureKeys(); track featureKey) {
        <li>{{ t(featureKey) }}</li>
      }
    </ul>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayFeatureListComponent {
  readonly featureKeys = input.required<string[]>();
}
